import React from 'react'
import OrderDetailsContainer from './OrderDetailsContainer'
import OrderMethodContainer from './OrderMethodContainer'
import { useSelector } from 'react-redux'
import { ReactComponent as CartEmptyIcon } from '../../assets/icons/cart-empty.svg'
import { useTranslation } from 'react-i18next'

const CartContainer = ({ setStepOrder, stepOrder }) => {
    const { ordering, ordered } = useSelector(state => state.OrderReducer)
    const { t } = useTranslation()

    const isCartEmpty = !ordering.length && !ordered.length

    return (
        <div className="food-desk-cart">
            <div className="cart-content" id="cart-content">
                <div className="cart-title">{t('cartDesktop.title')}</div>
                {isCartEmpty ? (
                    <div className="cart-content__empty">
                        <CartEmptyIcon fill="#18A0FB" />
                        <p style={{ textAlign: 'center' }}>
                            {t('cartDesktop.lbCartEmpty')}
                        </p>
                    </div>
                ) : (
                    <>
                        <OrderMethodContainer />
                        <OrderDetailsContainer
                            setStepOrder={setStepOrder}
                            stepOrder={stepOrder}
                        />
                    </>
                )}
            </div>
        </div>
    )
}

export default CartContainer
